import { ActionService } from 'phoenix/services/actionService';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
require('./dropUploadWrapper.styles');
/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaDropUploadWrapper
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaDropUploadWrapper` enables element to show and hide what should be dropped on
 *
 * @usage
 *
 * <sba-element sba-drop-upload-wrapper /> 
 * 
 */
export function DropUploadWrapperDirective(pxActionService:ActionService, gettextCatalog:ng.gettext.gettextCatalog) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {

			const enabled = () => {
				let val = true;
				let attr = attrs['sbaDropUploadEnabled'];
				if (attr === false || attr === 'false') {
					val = false;
				}

				return val;
			}
						
			pxActionService.subscribe(AppAction.DragToMove, () => {
				element.addClass("sba-dragging-inside");
			});

			pxActionService.subscribe(AppAction.EndDrag, () => {
				element.removeClass("sba-drop-upload-target---active sba-dragging-inside");
			});
			
			var detailsText = attrs['sbaDropUploadWrapper'] ? attrs['sbaDropUploadWrapper'] : gettextCatalog.getString('Drop here to upload');
			var uiElm= 	'<div class="sba__drop-upload-indicator">'+
						'	<div class="sba__drop-upload-indicator-top" aria-hidden="true">'+					
						'		<md-icon class="material-icons sba__drop-upload-indicator-top-icon app--accent-link">local_movies</md-icon>'+
						'		<md-icon class="material-icons sba__drop-upload-indicator-top-icon app--accent-link">description</md-icon>'+
						'		<md-icon class="material-icons sba__drop-upload-indicator-top-icon app--accent-link">insert_photo</md-icon>'+
						'	</div>'+
						'	<div class="sba__drop-upload-indicator-bottom" aria-hidden="true">'+					
						'		<md-icon class="material-icons sba__drop-upload-indicator-bottom-icon">cloud</md-icon>'+
						'		<div class="sba__drop-upload-indicator-bottom-text layout-row layout-align-center-center" layout="column" layout-align="center stretch">'+						
						'			<div>'+ detailsText + '</div>'+
						'		</div>'+
						'	</div>'+
						'</div>';
			//append the element with the helper control;
			element.append(uiElm);
			element.addClass('sba-drop-upload-wrapper');
			var doc = angular.element(document);
			element.on('dragover dragenter', function(e) {
				if (enabled()) {
					element.addClass('sba-dragging-inside');	
					//once the drag begins if the body gets a drag event its been dragged outside of container
					doc.on('dragover dragenter', clearDragging)
						.on('keyup', keyboarClearDragging);						
				}							
			})
			.on('dragleave dragend', function(e) {
				var containingTarget = e.target.closest('[sba-drop-upload-wrapper]');
				if(containingTarget === element[0]){ 
					e.preventDefault();
					e.stopPropagation();
					return false; 
				}
				clearDragging();
			})
			.on('droppedonchild', function(){
				clearDragging();
			})
			.on('dragenterchild', function(e){
				element.addClass('sba-dragging-inside');
			})
			.on('drop',function(e){
				element.removeClass('sba-dragging-inside');
			});         

			function keyboarClearDragging(e){
				if (e.keyCode === 27){ //escape key
					clearDragging();
				}
			}
			function clearDragging(){
				element.removeClass('sba-dragging-inside');					
				angular.element(document.querySelectorAll('.sba-drop-upload-target---active')).removeClass('sba-drop-upload-target---active');
				doc.off('dragover dragenter', clearDragging);
				doc.off('keyup', keyboarClearDragging);
			}

			scope.$on('$destroy',function(){
				element.off('dragover dragenter dragleave dragend droppedonchild drop');
				clearDragging();
			});
			
		}
	};
}

DropUploadWrapperDirective.$inject = [
	'pxActionService',
	'gettextCatalog'
];



// WEBPACK FOOTER //
// ./src/sharebase-app/components/dropUploadWrapper/dropUploadWrapper.ts